import React, {useEffect, useState} from "react";
import supplierApi from "../../../../api/suppliers";
import SupplierTable from "./SupplierTable";
import Loader from "../../../../components/Loader";
import notyf from "../../../../utils/notyfApi";

export default function SupplierTableHandler() {
    //get data from api
    const [supplier, setSupplier] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const response = await supplierApi.getAllSuppliers();
        if (!response.ok) return notyf.error("Error " + response.status)
        setSupplier({suppliers: response.data});
        setLoading(false)

    };

    //laat tabel zien met gegevens via props
    if (loading) return <Loader/> ;
    else return  <SupplierTable dataSource={supplier} reload={getData}/>;
}
